import { LotteryType, LotteryFlag } from '@/services/lottery';
import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { Page } from '@/config/track-config';

interface LotteryButtonGroupProps {
  remainingTickets: number;
  lotteryStatus: LotteryFlag;
  onLotteryStart: (type: LotteryType) => void;
}

export const LotteryButtonGroup = ({
  remainingTickets,
  lotteryStatus,
  onLotteryStart,
}: LotteryButtonGroupProps) => {
  const fm = useFm();

  const isNotEnoughStock = lotteryStatus === LotteryFlag.NotEnoughStock;
  const isLotteryCalculating = lotteryStatus === LotteryFlag.Calculating;
  const isLotteryUnavailable = isNotEnoughStock || isLotteryCalculating;

  if (remainingTickets <= 0) {
    return (
      <Button className="btn-brand" disabled>
        {fm('noTicket')}
      </Button>
    );
  }

  // 剩余次数小于10，只显示单抽按钮
  if (remainingTickets < 10) {
    if (isLotteryUnavailable) {
      return (
        <Button className="btn-brand" disabled>
          {fm('raffleAmount', { amount: 1 })}
        </Button>
      );
    }

    return (
      <Button
        className="btn-brand"
        data-spm-even="Web3UserClick"
        data-spm-data={JSON.stringify({
          page_name: Page.RewardsPage,
          button_name: 'Web3Points_Draw1',
        })}
        onClick={() => onLotteryStart(LotteryType.Single)}
      >
        {fm('raffleAmount', { amount: 1 })}
      </Button>
    );
  }

  if (isLotteryUnavailable) {
    return (
      <div className="flex items-center gap-4">
        <Button className="btn-brand" disabled>
          {fm('raffleAmount', { amount: 1 })}
        </Button>
        <Button className="btn-brand-linear" disabled>
          <div className="flex items-center gap-2">
            <img
              src={
                'https://s1.bycsi.com/bybit/deadpool/image-4ab3b47936a5479ba234f5fd29689920.png'
              }
              alt="token"
              width={16}
              height={16}
            />
            {fm('raffleAmount', { amount: 10 })}
          </div>
        </Button>
      </div>
    );
  }

  // 正常状态显示双按钮
  return (
    <div className="flex items-center gap-4">
      <Button
        className="btn-brand"
        data-spm-even="Web3UserClick"
        data-spm-data={JSON.stringify({
          page_name: Page.RewardsPage,
          button_name: 'Web3Points_Draw1',
        })}
        onClick={() => onLotteryStart(LotteryType.Single)}
      >
        {fm('raffleAmount', { amount: 1 })}
      </Button>
      <Button
        className="btn-brand-linear"
        data-spm-even="Web3UserClick"
        data-spm-data={JSON.stringify({
          page_name: Page.RewardsPage,
          button_name: 'Web3Points_Draw10',
        })}
        onClick={() => onLotteryStart(LotteryType.TenTimes)}
      >
        <div className="flex items-center gap-2">
          <img
            src={
              'https://s1.bycsi.com/bybit/deadpool/image-4ab3b47936a5479ba234f5fd29689920.png'
            }
            alt="token"
            width={16}
            height={16}
          />
          {fm('raffleAmount', { amount: 10 })}
        </div>
      </Button>
    </div>
  );
};
